import PageHeader from '../../components/PageHeader';
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  TextField,
  InputAdornment,
  Button,
  Stack,
} from '@mui/material';
import {
  Search as SearchIcon,
  Refresh as RefreshIcon,
  Add as AddIcon,
} from '@mui/icons-material';

const DailyMileagePage: React.FC = () => {
  const [mileageData, setMileageData] = useState([
    {
      id: 1,
      vehicle: 'Vehicle 1',
      date: '2024-01-15',
      startMileage: 12500,
      endMileage: 12800,
      totalMiles: 300,
      driver: 'John Doe',
      status: 'completed',
    },
    {
      id: 2,
      vehicle: 'Vehicle 2',
      date: '2024-01-15',
      startMileage: 8900,
      endMileage: 9200,
      totalMiles: 300,
      driver: 'Jane Smith',
      status: 'completed',
    },
  ]);

  return (
    <Box>
      <PageHeader title="Daily Mileage" description="Review daily distances and vehicle mileage" icon="mileage" />

      {/* Summary Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Total Miles Today
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                1,250
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Active Vehicles
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'success.main' }}>
                8
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Average Miles/Vehicle
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                156
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Fuel Efficiency
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'info.main' }}>
                16.3 mpg
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Controls */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                placeholder="Search vehicles or drivers..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} display="flex" justifyContent="flex-end" gap={1}>
              <Button variant="outlined" startIcon={<RefreshIcon />}>
                Refresh
              </Button>
              <Button variant="contained" startIcon={<AddIcon />}>
                Add Entry
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Mileage Table */}
      <Card>
        <CardContent>
          <Box sx={{ width: '100%', overflowX: 'auto' }}><Table>
            <TableHead>
              <TableRow>
                <TableCell>Vehicle</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Start Mileage</TableCell>
                <TableCell>End Mileage</TableCell>
                <TableCell>Total Miles</TableCell>
                <TableCell>Driver</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mileageData.map((entry) => (
                <TableRow key={entry.id} hover>
                  <TableCell>{entry.vehicle}</TableCell>
                  <TableCell>{entry.date}</TableCell>
                  <TableCell>{entry.startMileage.toLocaleString()}</TableCell>
                  <TableCell>{entry.endMileage.toLocaleString()}</TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                      {entry.totalMiles} miles
                    </Typography>
                  </TableCell>
                  <TableCell>{entry.driver}</TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      color={entry.status === 'completed' ? 'success' : 'warning'}
                      label={entry.status}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table></Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DailyMileagePage;
